const AUTHENTIK_APP_SLUG = 'core';

// Front-channel logout: oauth2-proxy clears the ffauth_* cookie, then authentik's
// end-session runs the gateway-invalidation flow, which clears authentik_session and
// redirects to the post-logout landing. That landing is a redirect stage in the flow --
// authentik 2025.10.0's EndSessionView ignores post_logout_redirect_uri and id_token_hint
// entirely, and sending them would break logout on a version that validates them.
export function buildSignOutUrl() {
  // merchant-portal's host is app.<env>; authentik lives at access.<env>.
  const authentikHost = window.location.hostname.replace(/^app\./, 'access.');

  const url = new URL('/oauth2/sign_out', window.location.origin);
  url.searchParams.set(
    'rd',
    `https://${authentikHost}/application/o/${AUTHENTIK_APP_SLUG}/end-session/`
  );
  return url;
}
